module.exports = __webpack_public_path__ + "img/change.eba49ed2.svg";